import clsx from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  description?: ReactNode
  icon?: ReactNode
  /** Action(s) — typically a single primary Button. */
  action?: ReactNode
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  className,
  ...rest
}: EmptyStateProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center gap-2 rounded-[var(--radius)]',
        'border border-dashed border-[var(--border)] bg-[var(--bg-2)] px-4 py-8 text-center',
        className,
      )}
      {...rest}
    >
      {icon ? (
        <span aria-hidden="true" className="text-[var(--text-2)]">
          {icon}
        </span>
      ) : null}
      <h3 className="text-[15px] font-semibold text-[var(--text)]">{title}</h3>
      {description ? (
        <p className="max-w-md text-[13px] text-[var(--text-2)]">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  )
}
